import PropTypes from 'prop-types';

export default PropTypes.shape({
  s: PropTypes.object,
  m: PropTypes.object,
  l: PropTypes.object,
});


// WEBPACK FOOTER //
// ./src/lib/CustomPropTypes/dimensions.js